import React from 'react'
import { IconsProps } from 'msp-integrations'

const CustomizabilityIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
    >
      <path d="M7.04 14.21h1.93c1.04 0 1.84-.71 2.04-1.73h10.96v-1H11.02c-.19-1.03-.99-1.73-2.04-1.74H7.04c-1.05 0-1.84.71-2.04 1.74H2v1h3c.2 1.03 1 1.73 2.04 1.73zm0-3.46h1.93c.64 0 1.09.51 1.09 1.23 0 .85-.55 1.23-1.09 1.23H7.04c-.64 0-1.09-.51-1.09-1.23 0-.85.55-1.23 1.09-1.23zM14 8.24h1.93c1.04-.01 1.84-.71 2.03-1.74h3.96v-1h-3.97c-.2-1.02-.99-1.72-2.03-1.72H14c-1.04 0-1.83.7-2.03 1.72H2.03v1h9.94c.19 1.02.99 1.73 2.03 1.74zm0-3.46h1.92c.64 0 1.09.51 1.09 1.23 0 .85-.55 1.23-1.08 1.23h-1.92c-.64 0-1.09-.51-1.09-1.23 0-.85.54-1.23 1.08-1.23zm5.92 10.98h-1.93c-1.04 0-1.82.7-2.03 1.71H2v1h13.95c.19 1.03.99 1.74 2.04 1.75h1.93c1.21-.01 2.08-.94 2.08-2.23 0-1.26-.9-2.22-2.08-2.23zm0 3.46H18c-.64 0-1.09-.51-1.09-1.23 0-.85.55-1.23 1.08-1.23h1.93c.64 0 1.09.51 1.09 1.23-.01.72-.46 1.23-1.09 1.23z" />
    </svg>
  )
}

export default CustomizabilityIcon
